import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective } from 'ngx-mask';
import Swal from 'sweetalert2';
import { BenefInfoComponent } from '@shared/components/benef-info/benef-info.component';
import { MatDialog } from '@angular/material/dialog';
import { SearchMdicamentProComponent } from '@shared/components/search-mdicament-pro/search-mdicament-pro.component';
import { ViewEncapsulation } from '@angular/core';
import { AuthService } from '@core';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';
import { IntegerFormatPipe } from '@shared/pipe/integer-format.pipe';
import { MoneyFormatPipe } from '@shared/pipe/money-format.pipe';
import { SearchFormComponent } from '@shared/components/search-form/search-form.component';
import moment from 'moment';

@Component({
  selector: 'app-main-pharmacie',
  imports: [
    MoneyFormatPipe,
    CommonModule,
    NgSelectModule,
    NgxMaskDirective,
    BenefInfoComponent,
    FormsModule,
    SearchMdicamentProComponent,
    IntegerFormatPipe,
    SearchFormComponent,
  ],

  templateUrl: './main-pharmacie.component.html',
  styleUrl: './main-pharmacie.component.scss',
})
export class MainPharmacieComponent {
  groupedItemsMedicament: { [key: string]: any[] } = {};
  selectedTab = 'tab1';
  @Output() onSendBenefItem = new EventEmitter<any>();
  @Output() onClosePrescriptionMedocModal = new EventEmitter<any>();
  @Output() onGoToTab = new EventEmitter<any>();
  @Input() matricule: any;
  @Input() refreshPharmacieComponent: any;
  isNormalMode = true;

  current_medicament_id: any = '';
  reload = false;
  produit: string = '';
  clearText = false;
  posologie: string = '';
  frequence: string = '';
  renouvellement: string = '';
  quantite: number = 1;
  items: any = [];
  selectedMedoc: any = {};
  itemsMedicament: any = [];
  itemsMedicamentAservir: any = [];
  itemsToSubmit: any = [];
  groupedItemsMedicamentAservir: { [key: string]: any[] } = {};
  groupedAservirList: { key: string; items: any[] }[] = [];

  isLoading: boolean | undefined;
  isLoadingRenew: boolean | undefined;
  input_value: any;
  input_option = 'MAT';
  searchPlaceHolder = 'Entrez numéro matricule';

  user: any = {};
  isConsultationSuccess = false;
  itemConsultation: any = {};
  itemToAdd: any = {};
  itemToSave: any = {};
  itemsModePrescription = [
    { code: 'produit', libelle: 'Produit' },
    { code: 'molecule', libelle: 'Molécule' },
  ];
  itemBeneficiare: any = {};
  fileName1: any;
  currentFile: any;
  itemsAffection: any;
  cancelItemSelected: boolean = false;
  medocOriginal: any;
  showModal: boolean = false;
  selectedDetailItem: any = null;
  isLoadingCommande: boolean = false;
  currentMode: 'prescription' | 'renouvellement' | 'commande' = 'prescription';
  beneficiaireAutOselect: any;
  itemsGarantie: any;
  latitude: number | null = null;
  longitude: number | null = null;
  constructor(
    private restClient: RestClientService,
    private router: Router,
    private authService: AuthService,
    private utilities: UtilitiesService,
    private dialogModel: MatDialog,
  ) {
    this.user = this.authService.getCurrentUser();
    console.log('connected user: ', this.user);
    this.itemToAdd = { quantite: 1 };
    this.itemToSave.mode_prescription = 'produit';
    // this.getItemsAffection()
    this.itemToSave.date_prescription = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1, // getMonth() returns 0-11
      day: new Date().getDate(),
    };
    this.itemsMedicament = [];
    let activeBeneficiaire = this.authService.getActiveBeneficiaire();
    if (activeBeneficiaire.matricule) {
      this.searcheBenef(activeBeneficiaire.matricule);
    }

    this.beneficiaireAutOselect = this.authService.getActiveBeneficiaire();

    this.getItemsGarantie();

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          console.log('Captured Lat:', this.latitude, 'Lng:', this.longitude);
          let pos = { latitude: this.latitude, longitude: this.longitude };
          this.authService.setUserPosition(pos);
        },
        (error) => {
          console.error('Error capturing location:', error);
        },
      );
    } else {
      console.error('Geolocation not supported by this browser.');
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['refreshPharmacieComponent'] &&
      changes['refreshPharmacieComponent'].currentValue
    ) {
      let activeBeneficiaire = this.authService.getActiveBeneficiaire();
      if (activeBeneficiaire.matricule) {
        this.searcheBenef(activeBeneficiaire.matricule);
      }
    }
  }

  getItemsAffection() {
    let request = {
      index: 0,
      size: 1000,
      data: {},
    };

    this.restClient.post('affection/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsAffection = res.items;
          console.log('this.itemsAffection: ', this.itemsAffection);
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemsAffection = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsAffection = [];
      },
    );
  }
  getItemsPrescriptionActeRenouvellement() {
    this.currentMode = 'renouvellement';
    this.groupedItemsMedicament = {};
    this.isLoadingRenew = true;
    this.itemsMedicamentAservir = [];
    let request = {
      index: 0,
      size: 1000,
      filter_inf: {
        key: 'date_renouvellement',
        value: new Date(),
      },
      filter_sup: {
        key: 'date_renouvellement',
        value: (() => {
          const d = new Date();
          d.setDate(d.getDate() + 5);
          return d;
        })(),
      },
      data: {
        beneficiaire_id: this.itemBeneficiare.id,
        is_renewed: false,
      },
    };

    this.restClient.post('renouvellement/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoadingRenew = false;
        if (res && !res['hasError'] && res['items']) {
          // Aplatir : utiliser prescription_acte_object comme base, conserver renouvellement_id
          this.itemsMedicament = res.items.map((itm: any) => {
            const base = itm.prescription_acte_object || {};
            return {
              ...base,
              ...itm,
              renouvellement_id: itm.id,
            };
          });
          console.log('this.itemsMedicament (renew): ', this.itemsMedicament);
          this.selectAllMedicaments();
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemsMedicament = [];
        }
      },
      (error) => {
        this.isLoadingRenew = false;
        this.utilities.showSweetNotification(error, 'error');
        this.itemsMedicament = [];
      },
    );
  }

  getItemsCommandeMedicament() {
    this.currentMode = 'commande';
    this.groupedItemsMedicament = {};
    this.isLoadingCommande = true;
    this.itemsMedicamentAservir = [];
    let request = {
      index: 0,
      size: 1000,
      data: {
        // prestataire_id: this.user.prestataire_id,
      },
    };

    this.restClient
      .post('commandeMedicamentDetail/getByCriteria', request)
      .subscribe(
        (res: any) => {
          this.isLoadingCommande = false;
          if (res && !res['hasError'] && res['items']) {
            this.itemsMedicament = res.items;
            this.groupItemsByCodification();

            console.log('this.itemsMedicament: ', this.itemsMedicament);
            this.selectAllMedicaments();
          } else {
            this.utilities.showSweetNotification(
              res['status']['message'],
              'error',
            );
            this.itemsMedicament = [];
          }
        },
        (error) => {
          this.isLoadingCommande = false;
          this.utilities.showSweetNotification(error, 'error');
          this.itemsMedicament = [];
        },
      );
  }
  getItemsCommandeMedicamentDetail() {
    this.groupedItemsMedicament = {};
    this.isLoadingCommande = true;
    this.itemsMedicamentAservir = [];
    let request = {
      index: 0,
      size: 1000,
      data: {
        // prestataire_id: this.user.prestataire_id,
      },
    };

    this.restClient
      .post('commandeMedicamentDetail/getByCriteria', request)
      .subscribe(
        (res: any) => {
          this.isLoadingCommande = false;
          if (res && !res['hasError'] && res['items']) {
            this.itemsMedicament = res.items;
            this.groupItemsByCodification();

            console.log('this.itemsMedicament: ', this.itemsMedicament);
            this.selectAllMedicaments();
          } else {
            this.utilities.showSweetNotification(
              res['status']['message'],
              'error',
            );
            this.itemsMedicament = [];
          }
        },
        (error) => {
          this.isLoadingCommande = false;
          this.utilities.showSweetNotification(error, 'error');
          this.itemsMedicament = [];
        },
      );
  }

  getItemsGarantie() {
    let request = {
      index: 0,
      size: 1000,
      data: {},
    };

    this.restClient.post('garantie/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsGarantie = res.items;
          console.log('this.itemsGarantie: ', this.itemsGarantie);
          this.getItemsPrescriptionActe();
          // this.getItemsActe()

          this.itemConsultation.raison_consultation_id =
            this.itemsGarantie[0].id;
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemsGarantie = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsGarantie = [];
      },
    );
  }
  getItemsPrescriptionActe() {
    this.currentMode = 'prescription';
    if (!this.itemsGarantie || !this.itemsGarantie.length) return;
    let garantie_id =
      this.itemsGarantie.find((ig: any) => ig.codification == 'PHARMA')?.id ??
      null;

    if (!garantie_id) {
      return;
    }
    if (!this.itemBeneficiare.id) {
      return;
    }
    this.groupedItemsMedicament = {};
    this.isLoading = true;
    this.itemsMedicamentAservir = [];
    let request = {
      index: 0,
      type_prescription: 'MEDICAMENT',
      is_medicament_classique: true,
      size: 1000,
      data: {
        beneficiaire_id: this.itemBeneficiare.id,
        garantie_id: garantie_id,
      },
    };

    this.restClient.post('prescriptionActe/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsMedicament = res.items;
          this.groupItemsByCodification();

          console.log('this.itemsMedicament: ', this.itemsMedicament);
          this.itemsMedicament = this.itemsMedicament.filter(
            (it: any) =>
              it.count_pharma_non_hospit == 0 &&
              !it.is_expired &&
              !it.is_factured,
          );
          this.selectAllMedicaments();
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemsMedicament = [];
        }
      },
      (error) => {
        this.isLoading = false;
        this.utilities.showSweetNotification(error, 'error');
        this.itemsMedicament = [];
      },
    );
  }

  onMedocDeepSeek() {
    if (!this.itemsMedicamentAservir || !this.itemsMedicamentAservir.length) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner au moin un medicament',
        'error',
      );
      return;
    }

    // Ignorer les EP en attente et les items sans qty/prix — sans muter l'affichage
    this.itemsToSubmit = this.itemsMedicamentAservir.filter((ima: any) => {
      if (ima.is_entente_prealable) return false;
      const qty = Number(
        String(ima.quantite_pharmacie || '').replace(/\s/g, ''),
      );
      const px = Number(String(ima.prix_pharmacie || '').replace(/\s/g, ''));
      return qty > 0 && px > 0;
    });

    if (!this.itemsToSubmit.length) {
      this.utilities.showSweetNotification(
        'Aucun médicament avec quantité et prix renseignés à soumettre.',
        'error',
      );
      return;
    }
    this.itemToSave.montant_depassement = 0;
    this.itemToSave.message_depassement = 0;
    let request = {
      index: 0,
      size: 1000,
      data: {
        part_assurance: this.getTotalPartAssurance(),
        part_patient: this.getTotalPartPatient(),
        matricule: this.itemBeneficiare.matricule,
      },
    };

    this.restClient.post('bareme/deepSeekPharmacie', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['item']) {
          let response = res['item'];

          if (
            response.montant_depassement &&
            response.montant_depassement > 0
          ) {
            this.itemToSave.montant_depassement = response.montant_depassement;
            this.itemToSave.message_depassement = response.message_depassement;
            this.itemToSave.part_patient = response.part_patient;
            this.itemToSave.part_assurance = response.part_assurance;
          } else {
            this.confirmSaveItem(this.itemToSave);
          }
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
        }
      },
      (error) => {
        this.isLoading = false;
        this.utilities.showSweetNotification(error, 'error');
      },
    );
  }
  imprimerRecuVentePharmacie(vente: any) {
    // this.itemsMedicamentAservir = []
    let request = {
      index: 0,
      size: 1000,
      data: {
        id: vente.vente_pharmacie_id,
      },
    };

    this.restClient.post('ventePharmacie/generateRecu', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res.item) {
          window.open(res.item.file_url);
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          // this.itemsMedicament = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        // this.itemsMedicament = [];
      },
    );
  }

  onSelectTab(tab: string) {
    this.selectedTab = tab;
  }
  calculateTotalPartiel(item: any) {
    const qteMax =
      this.currentMode === 'renouvellement' && item.quantite_renew
        ? Number(item.quantite_renew)
        : Number(item.quantite);
    const qteSaisie = Number(
      String(item.quantite_pharmacie || '').replace(/\s/g, ''),
    );

    if (qteSaisie && qteSaisie > qteMax) {
      this.utilities.showSweetNotification(
        'La quantité servie ne peut être supérieure à la quantité prescrite: ' +
          qteMax,
        'error',
      );
      item.quantite_pharmacie = null;
      setTimeout(() => {
        item.quantite_pharmacie = qteMax;
      }, 0);
      return;
    }
    // if (item.quantite_pharmacie && item.quantite_pharmacie > item.quantite) {
    //   this.utilities.showSweetNotification(
    //     'Quantité approuvée dépassée.Maximum: ' + item.quantite,
    //     'error'
    //   );
    //   item.quantite_pharmacie = 0
    //   return
    // }
    const prix = Number(String(item.prix_pharmacie || '').replace(/\s/g, ''));
    const prixSys = Number(item.prix_systeme) || 0;

    if (!prix || !qteSaisie) {
      item.montant = 0;
      item.part_assurance = 0;
      item.part_patient = 0;
      return;
    }

    item.montant = prix * qteSaisie;

    // Médicament non garanti : 100% à charge patient
    if (item.is_exclu) {
      item.part_assurance = 0;
      item.part_patient = item.montant;
      return;
    }

    // Médicament garanti : calcul avec seuil toléré (prix_sys + 10%)
    const taux = this.itemBeneficiare?.taux_applicable || 0;
    const prixMax = prixSys * 1.1;

    if (prix > prixMax) {
      const base = prixMax * qteSaisie;
      const depassement = (prix - prixMax) * qteSaisie;
      item.part_assurance = (taux / 100) * base;
      item.part_patient = ((100 - taux) / 100) * base + depassement;
      this.utilities.showSweetNotification(
        `Dépassement du seuil toléré : un surplus de ${Math.round(depassement).toLocaleString('fr-FR')} FCFA` +
          ` sera supporté par le patient (prix supérieur au seuil toléré de ${Math.round(prixMax).toLocaleString('fr-FR')} FCFA).`,
        'warning',
      );
    } else {
      item.part_assurance = (taux / 100) * item.montant;
      item.part_patient = ((100 - taux) / 100) * item.montant;
    }
  }

  isGreaterThanNPercentAbove(number1: any, number2: any, n: any) {
    const threshold = number1 + (n / 100) * number1;
    return number2 > threshold;
  }

  getThreshold(number1: any, n: any) {
    return number1 + (n / 100) * number1;
  }

  getTotal() {
    let total = 0;
    if (this.itemsMedicamentAservir && this.itemsMedicamentAservir.length) {
      this.itemsMedicamentAservir.forEach((ima: any) => {
        const value = Number(ima.montant);
        if (!isNaN(value)) {
          total += value;
        }
      });
    }
    return total;
  }

  getTotalPartPatient() {
    let total = 0;
    if (this.itemsMedicamentAservir && this.itemsMedicamentAservir.length) {
      this.itemsMedicamentAservir.forEach((ima: any) => {
        const value = Number(ima.part_patient);
        if (!isNaN(value)) {
          total += value;
        }
      });
    }
    return total;
  }

  getTotalPartAssurance() {
    let total = 0;
    if (this.itemsMedicamentAservir && this.itemsMedicamentAservir.length) {
      this.itemsMedicamentAservir.forEach((ima: any) => {
        const value = Number(ima.part_assurance);
        if (!isNaN(value)) {
          total += value;
        }
      });
    }
    return total;
  }

  onChangeInputMode() {
    this.input_value = '';
    this.searchPlaceHolder =
      this.input_option == 'MAT'
        ? 'Entrez numéro matricule'
        : 'Entrez numéro cnam';
  }

  searcheBenef(activeBenefMatricule?: any) {
    if (!this.input_value && activeBenefMatricule) {
      this.input_value = activeBenefMatricule;
    }
    this.isLoading = false;
    this.isConsultationSuccess = false;
    let mat_form = {
      matricule: this.input_value,
    };

    this.itemBeneficiare = {};
    this.itemConsultation = {};

    let cmu_form = {
      numero_cnam: this.input_value,
    };
    if (!this.input_value) {
      const messages: { [key: string]: string } = {
        CMU: 'Veuillez reseigner numéro CMU',
        MAT: 'Veuillez reseigner numéro matricule',
      };

      const message = messages[this.input_option];

      if (message) {
        this.utilities.showSweetNotification(message, 'error');
        this.isLoading = false;
        return;
      }
    }

    let request = {
      // user_id:this.user.id,
      data: this.input_option == 'CMU' ? cmu_form : mat_form,
    };

    this.isLoading = true;

    this.restClient.post('beneficiaire/search', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError']) {
          this.itemBeneficiare = res.item;
          this.authService.setActiveBeneficiaire(res.item);
          this.getItemsPrescriptionActe();

          this.onSendBenefItem.emit(this.itemBeneficiare);
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemBeneficiare = {};
        }
      },
      (error) => {
        this.isLoading = false;
        this.utilities.showSweetNotification(error, 'error');
        this.itemBeneficiare = {};
      },
    );
  }
  searcheBenefCommande(activeBenefMatricule?: any) {
    if (!this.input_value && activeBenefMatricule) {
      this.input_value = activeBenefMatricule;
    }
    this.isLoadingRenew = false;
    this.isConsultationSuccess = false;
    let mat_form = {
      matricule: this.input_value,
    };

    this.itemBeneficiare = {};
    this.itemConsultation = {};

    let cmu_form = {
      numero_cnam: this.input_value,
    };
    if (!this.input_value) {
      const messages: { [key: string]: string } = {
        CMU: 'Veuillez reseigner numéro CMU',
        MAT: 'Veuillez reseigner numéro matricule',
      };

      const message = messages[this.input_option];

      if (message) {
        this.utilities.showSweetNotification(message, 'error');
        this.isLoadingRenew = false;
        return;
      }
    }

    let request = {
      // user_id:this.user.id,
      data: this.input_option == 'CMU' ? cmu_form : mat_form,
    };

    this.isLoadingRenew = true;

    this.restClient.post('beneficiaire/search', request).subscribe(
      (res: any) => {
        this.isLoadingRenew = false;
        if (res && !res['hasError']) {
          this.itemBeneficiare = res.item;
          this.authService.setActiveBeneficiaire(res.item);
          this.getItemsPrescriptionActeRenouvellement();

          this.onSendBenefItem.emit(this.itemBeneficiare);
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemBeneficiare = {};
        }
      },
      (error) => {
        this.isLoadingRenew = false;
        this.utilities.showSweetNotification(error, 'error');
        this.itemBeneficiare = {};
      },
    );
  }
  searcheBenefRenew(activeBenefMatricule?: any) {
    this.currentMode = 'renouvellement';
    if (!this.input_value && activeBenefMatricule) {
      this.input_value = activeBenefMatricule;
    }
    this.isLoadingRenew = false;
    this.isConsultationSuccess = false;
    let mat_form = {
      matricule: this.input_value,
    };

    this.itemBeneficiare = {};
    this.itemConsultation = {};

    let cmu_form = {
      numero_cnam: this.input_value,
    };
    if (!this.input_value) {
      const messages: { [key: string]: string } = {
        CMU: 'Veuillez reseigner numéro CMU',
        MAT: 'Veuillez reseigner numéro matricule',
      };

      const message = messages[this.input_option];

      if (message) {
        this.utilities.showSweetNotification(message, 'error');
        this.isLoadingRenew = false;
        return;
      }
    }

    let request = {
      // user_id:this.user.id,
      data: this.input_option == 'CMU' ? cmu_form : mat_form,
    };

    this.isLoadingRenew = true;

    this.restClient.post('beneficiaire/search', request).subscribe(
      (res: any) => {
        this.isLoadingRenew = false;
        if (res && !res['hasError']) {
          this.itemBeneficiare = res.item;
          this.authService.setActiveBeneficiaire(res.item);
          this.getItemsPrescriptionActeRenouvellement();

          this.onSendBenefItem.emit(this.itemBeneficiare);
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemBeneficiare = {};
        }
      },
      (error) => {
        this.isLoadingRenew = false;
        this.utilities.showSweetNotification(error, 'error');
        this.itemBeneficiare = {};
      },
    );
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const Tabextension = file.name.split('.');
      const extension = Tabextension[Tabextension.length - 1];

      console.info('fileName', fileName);
      console.info('extension', extension);
      this.fileName1 = fileName + '.' + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        // this.imageDisplay = data;
        const fileBase64 = data.split(',')[1];
        this.currentFile = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: 'custom type',
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  onGetDossiers() {}

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }

  confirmSaveItem(data: any) {
    // item.specialiteId = this.selectedSpecialite.id
    // if (!data || !data.affection_id) {
    //   this.utilities.showSweetNotification('Veuillez renseigner affection', 'error');
    //   return;
    // }
    // if (!data || !data.date_prescription) {
    //   this.utilities.showSweetNotification('Veuillez renseigner date prescription', 'error');
    //   return;
    // }
    // if (!data || !data.affection_id) {
    //   this.utilities.showSweetNotification('Veuillez renseigner affection', 'error');
    //   return;
    // }
    // if (!data || !data.mode_prescription) {
    //   this.utilities.showSweetNotification('Veuillez renseigner mode prescription', 'error');
    //   return;
    // }

    if (!this.itemsToSubmit || !this.itemsToSubmit.length) {
      this.utilities.showSweetNotification(
        'Aucun médicament à soumettre.',
        'error',
      );
      return;
    }

    Swal.fire({
      title: 'Vente de médicament',
      text: 'Souhaitez-vous poursuivre cette action?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.saveItems();
      }
    });
  }

  saveItems() {
    this.isConsultationSuccess = false;

    let file_data = '';
    if (this.currentFile && Object.keys(this.currentFile).length) {
      file_data = this.currentFile;
    }
    if (this.itemsToSubmit && this.itemsToSubmit.length) {
      const totalPartAssuranceOriginal = this.getTotalPartAssurance();
      const partAssuranceAjustee =
        this.itemToSave.part_assurance ?? totalPartAssuranceOriginal;

      this.itemsToSubmit.forEach((im: any) => {
        im.affection_id = this.itemToSave.affection_id;
        im.date_presription = this.itemToSave.date_presription;
        im.mode_prescription = this.itemToSave.mode_prescription;
        im.matricule = this.itemBeneficiare.matricule;
        im.beneficiaire_id = this.itemBeneficiare.id;
        im.quantite_vendue = im.quantite_pharmacie;
        im.prix_unitaire_vente = im.prix_pharmacie;
        im.prix_unitaire = im.prix_pharmacie;
        im.quantite_prescripte = im.quantite;
        im.prix_unitaire_systeme = im.prix_systeme;
        im.is_factured = false;
        im.latitude = this.latitude;
        im.longitude = this.longitude;
        im.taux_applicable = im.taux_appliquable;

        // Ajuster part_assurance/part_patient proportionnellement au résultat deepSeek
        const ratio =
          totalPartAssuranceOriginal > 0
            ? (im.part_assurance || 0) / totalPartAssuranceOriginal
            : 0;
        im.part_assurance = Math.round(partAssuranceAjustee * ratio);
        im.part_patient = (im.montant || 0) - im.part_assurance;
        im.part_patient_net = im.part_patient;
        im.part_assurance_net = im.part_assurance;

        im.prescription_acte_id = im.id;
        delete im.id;
      });
    }

    const firstItem = this.itemsToSubmit[0] || {};
    const dataSinistre: any = {
      filiale_id: firstItem.filiale_id,
      beneficiaire_id: this.itemBeneficiare?.id,
      prestataire_id: firstItem.prestataire_id,
      police_id: firstItem.police_id,
      college_id: firstItem.college_id,
      souscripteur_id: firstItem.souscripteur_id,
      garant_id: firstItem.garant_id,
      garantie_id: firstItem.garantie_id,
      exercice_id: firstItem.exercice_id,
      matricule: this.itemBeneficiare?.matricule,
      matricule_assure: firstItem.matricule_assure,
      montant: this.getTotal(),
      part_patient: this.itemToSave.part_patient ?? this.getTotalPartPatient(),
      part_assurance:
        this.itemToSave.part_assurance ?? this.getTotalPartAssurance(),
      depassement: this.itemToSave.montant_depassement || 0,
      statut: 'ATTENTE_PREVALIDATION_PRESTATAIRE',
    };

    const request: any = {
      montant: this.getTotal(),
      part_patient: this.itemToSave.part_patient ?? this.getTotalPartPatient(),
      part_assurance:
        this.itemToSave.part_assurance ?? this.getTotalPartAssurance(),
      dataSinistre,
      datas: this.itemsToSubmit.map(
        ({ prescription_acte_object, ...rest }: any) => rest,
      ),
    };

    this.restClient.post('prestationActe/create', request).subscribe(
      (res: any) => {
        if (res && !res['hasError']) {
          this.isConsultationSuccess = true;
          this.utilities.showSweetNotification(
            res['status']['message'],
            'succes',
          );
          this.itemToSave.montant_depassement = 0;
          this.itemToSave.message_depassement = 0;
          this.getItemsPrescriptionActe();
        } else {
          this.isConsultationSuccess = false;
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
        }
        this.onClosePrescriptionMedocModal.emit('hide');
      },
      (error) => {
        this.isConsultationSuccess = false;
        this.utilities.showSweetNotification(error, 'error');
      },
    );
  }

  addMedicament(): void {
    if (!this.selectedMedoc || this.selectedMedoc.is_entente_prealable) {
      this.utilities.showSweetNotification(
        'Veuillez choisir un médicament garanti svp',
        'error',
      );
      return;
    }
    if (!this.selectedMedoc || !this.selectedMedoc.id) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner le médicament',
        'error',
      );
      return;
    }
    if (!this.itemToAdd.quantite) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner la quantité',
        'error',
      );
      return;
    }
    if (!this.itemToAdd.posologie) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner la posologie',
        'error',
      );
      return;
    }
    if (!this.itemToAdd.duree) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner la durée',
        'error',
      );
      return;
    }
    if (!this.itemToAdd.prix) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner le prix',
        'error',
      );
      return;
    }
    // console.log("this.itemToAdd.prix: ",this.itemToAdd.prix)
    // console.log("this.medocOriginal: ",this.medocOriginal)
    if (this.itemToAdd.prix > this.medocOriginal.prix_systeme) {
      this.utilities.showSweetNotification(
        'Le prix du substitut doit etre inférieur ou égal au produit substitué: ' +
          this.medocOriginal.prix_systeme,
        'error',
      );
      return;
    }

    // let obj = {
    //   is_entente_prealable: this.selectedMedoc.is_entente_prealable,
    //   is_exclu: this.selectedMedoc.is_exclu,
    //   medicament_id: this.selectedMedoc.id,
    //   medicament_libelle: this.selectedMedoc.libelle,
    //   forme_medicament_libelle: this.selectedMedoc.forme_medicament_libelle,
    //   posologie: this.itemToAdd.posologie,
    //   duree: this.itemToAdd.duree,
    //   is_renewable: 0,
    //   // is_renewable: this.itemToAdd.is_renewable || false,
    //   // quantite_renew: this.itemToAdd.quantite_renew || 0,
    //   // is_consultation_required_renew: this.itemToAdd.is_consultation_required_renew || false,
    //   // frequence_renew: this.itemToAdd.frequence_renew,
    //   // dure_renew: this.itemToAdd.dure_renew || 0,
    //   quantite: this.itemToAdd.quantite
    // }

    if (!this.itemsGarantie || !this.itemsGarantie.length) return;
    let garantie_id = this.itemsGarantie.find(
      (ig: any) => ig.codification == 'PHARMA',
    ).id;

    let obj = {
      college_id: this.medocOriginal.college_id,
      police_id: this.medocOriginal.police_id,
      ordonnance_id: this.medocOriginal.ordonnance_id,
      ordonnance_code: this.medocOriginal.ordonnance_code,
      ordonnance_codification: this.medocOriginal.ordonnance_codification,
      ordonnance_prestataire_id: this.medocOriginal.ordonnance_prestataire_id,
      prescription_pharmacie_id: this.medocOriginal.id,
      souscripteur_id: this.medocOriginal.souscripteur_id,
      garant_id: this.medocOriginal.garant_id,
      affection_id: this.medocOriginal.affection_id,
      prestation_id: this.medocOriginal.prestation_id,
      dossier_id: this.medocOriginal.dossier_id,
      prescription_pharmacie_replaced_id: this.medocOriginal.id,
      garantie_id: garantie_id,
      medicament_libelle: this.selectedMedoc.libelle,
      forme_medicament_libelle: this.selectedMedoc.forme_medicament_libelle,
      medicament_id: this.selectedMedoc.id,
      quantite: this.medocOriginal.quantite,
      duree: this.itemToAdd.quantite,
      posologie: this.itemToAdd.posologie,
      is_pending_validate: 0,
      is_entente_prealable: 0,
      is_exclu: 0,
      prix_systeme: this.itemToAdd.prix,
      prix_unitaire_systeme: this.itemToAdd.prix,
      is_replacer: true,
      prestataire_libelle: this.user.prestataire_libelle,
      prestataire_id: this.user.prestataire_id,
    };

    this.itemsMedicament.find((im: any) => {
      if (im.id == this.medocOriginal.id) {
        im.is_replaced = true;
      }
    });

    console.log('obj: ', obj);
    // this.itemsMedicament.unshift({ ...obj })
    this.itemsMedicament.push({ ...obj });

    // this.clearText = true
    // this.reload = !this.reload
    // this.itemToAdd = { quantite: 1 }
    this.showModal = false;
    this.groupItemsByCodification();

    console.log('items medoc after substitution: ', this.itemsMedicament);
  }

  onSelectMedoc(event: any) {
    console.log('current medoc', event);
    this.selectedMedoc = event || {};
  }

  goNext() {
    this.onGoToTab.emit('pharmacie');
  }

  addMedicamentToList(item: any) {
    item.is_added = true;
    this.itemsMedicamentAservir = this.itemsMedicament.filter(
      (itm: any) => itm.is_added == true,
    );
  }
  removeMedicamentFromList(item: any) {
    // item.is_added=true
    this.itemsMedicament.map((itm: any) => {
      if (itm.id == item.id) {
        itm.is_added = false;
      }
    });
    this.itemsMedicamentAservir = this.itemsMedicament.filter(
      (itm: any) => itm.is_added == true,
    );
    this.groupItemsAservirByOrdonnance();
  }

  removeItem(index: number): void {
    if (confirm('Êtes-vous sûr de vouloir supprimer cet élément?')) {
      this.itemsMedicament.splice(index, 1);
    }
  }

  openSubstitutionModal(item: any) {
    this.medocOriginal = { ...item };
    this.selectedMedoc = {};
    this.itemToAdd = {};
    this.itemToAdd.quantite = this.medocOriginal.quantite;
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  // dialog() {
  //   this.simpleDialog = this.dialogModel.open(SimpleDialogComponent);
  // }
  // openDialog(): void {
  //   this.dialogModel.open(DialogformComponent, {
  //     width: '640px',
  //     disableClose: true,
  //   });
  // }

  openModal(content: any, item: any) {
    this.medocOriginal = { ...item };
  }

  reloadMedoc() {
    this.cancelItemSelected = false;
    setTimeout(() => {
      this.cancelItemSelected = true;
    }, 0);
  }

  onSelectMedocPro(event: any) {
    console.log('medoc substitue', event);
    console.log('medocOriginal', this.medocOriginal);
    if (event.is_exclu || event.is_entente_prealable) {
      this.utilities.showSweetNotification(
        'Ce médicament ne peut pas être utilisé comme substitut (non garanti ou en entente préalable).',
        'error',
      );
      this.reloadMedoc();
      return;
    }
    const prixSysOriginal = this.medocOriginal?.prix_systeme || 0;
    if (prixSysOriginal > 0 && (event.prix || 0) > prixSysOriginal) {
      this.utilities.showSweetNotification(
        `Le prix du substitut (${event.prix}) dépasse le prix système du médicament d'origine (${prixSysOriginal}). Substitution non autorisée.`,
        'error',
      );
      this.reloadMedoc();
      return;
    }
    this.selectedMedoc = { ...event };
    this.itemToAdd.prix = this.selectedMedoc.prix;
  }

  groupItemsByCodification() {
    this.groupedItemsMedicament = this.itemsMedicament.reduce(
      (
        acc: { [x: string]: any[] },
        item: { ordonnance_codification: string },
      ) => {
        const key = item.ordonnance_codification || 'Autres';
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      },
      {} as { [key: string]: any[] },
    );
  }

  selectAllMedicaments() {
    this.itemsMedicament.forEach((itm: any) => {
      itm.is_added = true;
      if (!itm.is_entente_prealable) {
        if (!itm.quantite_pharmacie) {
          itm.quantite_pharmacie =
            this.currentMode === 'renouvellement' && itm.quantite_renew
              ? itm.quantite_renew
              : itm.quantite;
        }
        // prix non pré-rempli : l'utilisateur doit le saisir
      }
    });
    this.itemsMedicamentAservir = [...this.itemsMedicament];
    this.groupItemsAservirByOrdonnance();
  }

  groupItemsAservirByOrdonnance() {
    this.groupedItemsMedicamentAservir = this.itemsMedicamentAservir.reduce(
      (acc: { [key: string]: any[] }, item: any) => {
        const key =
          item.ordonnance_code ||
          item.ordonnance_codification ||
          'Sans ordonnance';
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      },
      {} as { [key: string]: any[] },
    );
    this.groupedAservirList = Object.entries(
      this.groupedItemsMedicamentAservir,
    ).map(([key, items]) => ({ key, items }));
  }

  canAdd(item: any): boolean {
    return (
      item.quantite > 0 &&
      !item.is_added &&
      !item.is_replaced &&
      !item.is_entente_prealable &&
      !item.is_exclu
    );
  }

  get canServirMedocEnDetail(): boolean {
    // null/undefined/0 = non, 1 = oui
    return this.user?.can_servir_medoc_en_detail == 1;
  }

  canSubstitute(item: any): boolean {
    return (
      this.currentMode !== 'renouvellement' &&
      item.quantite > 0 &&
      !item.is_replaced &&
      !item.is_replacer &&
      !item.is_exclu &&
      !item.is_entente_prealable
    );
  }

  // onSetUserInfo(event: any) {
  //   if (event.id) {
  //     this.itemBeneficiare = event
  //     this.getItemsPrescriptionActe()
  //   }

  // }

  onSetUserInfo(event: any) {
    if (event.id) {
      this.itemBeneficiare = event;
      this.authService.setActiveBeneficiaire(event);
      this.itemConsultation = {};
      this.beneficiaireAutOselect = this.itemBeneficiare;
      // this.getItemsPrescriptionActe()
      this.getItemsGarantie();
    } else {
      this.authService.setActiveBeneficiaire({});
      this.beneficiaireAutOselect = {};
    }
  }
}
